export const KEY_CODES = {
  ENTER: 13,
  ESCAPE: 27,
  TAB: 9,
}

export function isEnterKey(e) {
  return e.key === "Enter"
}

export function isEscapeKey(e) {
  return e.key === "Escape"
}
